import { FormFieldLabels } from "../components/Proposal/Models/IFieldDescription";

const enStrings: FormFieldLabels = {
    "NoOfMilestone": "No of milestone",
    "Milestone": "Milestone",
    "StartDate": "Start date",
    "EndDate": "End date",
    "Comments": "Comments",
    "NumberOfPublishedArticlesAsPI": "Number of published articles in international peer-reviewed journals (as PI):",
    "NumberOfPublications": "Number of publications",
    "TypeOfStudy": "Type of study",
    "SelectType": "Select a type",
    "Title": "Title",
    "IndustryPartner": "Industry partner, if any",
    "Monitoring": "Monitoring",
    "Name": "Name",
    "DataManagement": "Data management",
    "Analysis": "Analysis",
    "ApplicantName": "Applicant Name",
    "ApplicantEmail": "Applicant Email",
    "InstituteName": "Institute Name",
    "Street": "Street",
    "No": "No",
    "PostalCode": "Postal Code",
    "City": "City",
    "Country": "Country",
    "StateForUSAddresses": "State (for US addresses)",
    "Email": "Email",
    "Phone": "Phone",
    "FirstName": "Firstname",
    "LastName": "Lastname",
    "Institute": "Institute",
    "Add": "Add",
    "Remove": "Remove",
    "MaterialsAndMethods": "Materials and Methods",
    "DescribePopulationAndIndication": "Describe population and indication",
    "DescribeTreatments": "Describe treatments",
    "DescribeExperimentalProceduresAndFollowUps": "Describe experimental procedures and follow-ups",
    "DescribeStudyProcedures": "Please describe study procedures, including patient population, measurements, time-points of assessments, etc",
    "StatisticalMethods": "Statistical methods",
    "PrimaryOutcomeParameter": "Primary outcome parameter",
    "ParameterName": "Parameter name (e.g. Marginal Bone Level, Implant Survival, etc.)",
    "DescribeParameter": "Describe parameter here (e.g. reliability, scale, etc.)",
    "BaselineMeasurement": "Baseline measurement (e.g. at loading)",
    "Endpoint": "Endpoint (e.g. 12 months after loading)",
    "ProjectPlan": "Project Plan",
    "PublicationAndPresentationPlan": "Publication and Presentation plan",
    "PresentResearchDetails": "Please describe where you plan to present your research (congress and/or journal)",
    "RequestedSupport": "Requested Support",
    "FundsRequested": "Funds requested",
    "Currency": "Please state your currency",
    "CostTypeItem": "Cost type / item",
    "RequestedFunds": "Requested funds",
    "RequiresOverhead": "Requires overhead",
    "CostTypeItemDetails": "Cost type / item (e.g. CBCT, patient stipend, journal costs, other direct costs)",
    "PercentageOfRequiredOverhead": "% of required overhead / administrative costs",
    "TotalRequestedFunds": "Total requested funds",
    "OverheadCosts": "Overhead costs",
    "TotalCurrency": "Total (currency)",
    "StudyMaterialRequested": "StudyMaterialRequested",
    "ArticleDescription": "ArticleDescription",
    "ArticleNumber": "ArticleNumber",
    "Qty": "Qty",
    "Search": "Search",
    "DiscsForInVitroStudies": "Discs for in vitro studies",
    "Dimensions": "Dimensions",
    "Quantity": "Quantiy",
    "MaterialSearch": "Material Search",
    "TypePartOfMaterialNumber": "Type part of Material Number or Name",
    "Clear": "Clear",
    "FulltextSearch": "Fulltext Search",
    "SearchError": "An error occurred during search",
    "SearchResults": "Search Results",
    "SelectMaterial": "Select Material",
    "NoMaterialsFound": "No Materials found, please try another search term",
    "StudyDescription": "Study Description",
    "StudyTitle": "Study Title",
    "Summary": "Summary",
    "BackgroundAndRationale": "Background and rationale",
    "PrimaryStudyHypothesis": "Primary study hypothesis",
    "Brand": "Brand",
    "Other": "Other",
    "AddCustomBrand": "Add custom brand",
    "AddCustomTypeOfStudy": "Add custom type of study",
    "StudyDesign": "Study Design",
    "Fields": "Fields",
    "Others": "Others",
    "AddOthers": "Add others",
    "StudyInterventions": "Study Interventions",
    "StudyInterventionTestArm": "Study Intervention - Test Arm",
    "DeviceName": "Device name",
    "TreatmentName": "Treatment name (please add a short title to your test group)",
    "TreatmentDescription": "Treatment description",
    "ControlInterventionControlArm": "Control Intervention – Control Arm",
    "DeviceNameIfApplicable": "Device name, if applicable",
    "TreatmentNameIfApplicable": "Treatment name (please add a short title to your test group), if applicable",
    "TreatmentDescriptionIfApplicable": "Treatment description, if applicable",
    "AdditionalStudyArms": "Additional Study arms",
    "StudyPower": "Study Power",
    "NTotal": "N total",
    "NPerGroup": "N per group",
    "AnticipatedDropOutRate": "Anticipated drop-out rate %",
    "AdequatePowerAnalysisAndJustification": "Adequate power analysis and justification"
}

export default enStrings;